import React, { useState, useEffect, useContext } from 'react';
import firebase from '../components/config/Fire';
import { storage } from "../components/config/Fire";
import Axios from "axios";
// import { AuthContext } from '../../context/Auth';
import parse from 'html-react-parser';

import { Container, Row,Col, Button,Card, Modal, Form } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";


const Home = () => {
  
  const handleClose = () => {
    setShowModal(false);
  };
  
  const [postData, setPostData] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  useEffect(() => {
    getPostData();
  }, []);

  const getPostData = () => {
    // Axios
    // .get(`https://software-bazaar-default-rtdb.firebaseio.com/event.json`)
    firebase.database().ref(`receipe`).get()
      .then((response) => {
        setPostData(response.val())
        // setTimeout(setPostData(response.val()), 5000);
        // setLoading(false);
      })
      .catch((error) => console.log(error));
  };

  const handleShow = (postData) => {
    setSelectedPost(postData);
    setShowModal(true);
  };

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredData = postData ? Object.entries(postData)
  .filter(item => item[1].postTopicName.toLowerCase().includes(searchQuery.toLowerCase()))
  .sort((a, b) => a[1].postPositionNo - b[1].postPositionNo) : [];

  
  const handleFormSubmit = async (values, actions) => {
    console.log("form", values);
    try {
      await axios.post(
        `https://food-receipe-dashboard-default-rtdb.firebaseio.com/subscribe.json`,
        values
      );
      actions.resetForm();
      actions.setSubmitting(false);
      alert("Form submitted successfully.");
      window.location.reload();
    } catch (error) {
      console.error("Error submitting form:", error);
      actions.setSubmitting(false);
    }
  };
  
  return (
    <>
      <section className='banner bg-dark-overlay'>
        <Container>
          <Row>
            <Col lg={12}>
              <div className='text-center text-light'>
            <h1 className='head-size'>Explore Delicious Recipes</h1>
            <h5>Discover mouth-watering recipes from our collection. Perfect for home cooking and food enthusiasts.</h5>

            <Formik
                initialValues={{
                 
                  email: "",
                  
                  postTimestamp: new Date().toUTCString(),
                }}
                validationSchema={Yup.object().shape({
                  

                  email: Yup.string()
                    .email("Invalid email address")
                    .required("Please enter your email address."),
                 
                })}
                onSubmit={handleFormSubmit}
              >
                {(formik) => (
                  <Form method="post">
                   <div className='d-flex justify-content-center mt-4'>
                    
                    <Form.Group
                      className="mb-3 me-3"
                      controlId="exampleForm.ControlInput1"
                    ><Field
                    className={`form-control ${
                      formik.touched.email && formik.errors.email
                        ? "is-invalid"
                        : ""
                    }`}
                    type="email"
                    name="email"
                    placeholder=" Enter Email address"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="invalid-feedback"
                  />
                </Form.Group>
               
                
                <Button
                      variant="light"
                      className="rounded-3 subsbtn"
                      type="submit"
                      onClick={formik.handleSubmit}
                    >
                      Subscribe
                    </Button>
                    </div>
                  
                  </Form>
                )}
              </Formik>
            </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      <section className='reciepe py-4'>
        <Container>
          <Row>
          <Col lg={12}>
            <Form className="d-flex my-5">
            <Form.Control
              type="search"
              placeholder="Search Receipes..."
              className="me-2"
              aria-label="Search"
              value={searchQuery}
            onChange={handleSearchChange}
            />
            <Button variant="outline-success">Search</Button>
          </Form>
            </Col>
            {postData && filteredData.length > 0 ? (
    filteredData.map((item) => (
            <Col lg={4} className='cardmargin mb-4'>
            <Card className='shadow h-100'>
            <Card.Img variant="top" src={item[1].postImage} alt='project1'/>
            <Card.Body>
              <Card.Title className='cardtitle'>{item[1].postTopicName}</Card.Title>
              <Card.Text className='cardtxt'>
              {parse(`${item[1].postLongDetail.substring(0, 100)}...`)}
              <div className='text-center'>
              {/* <Button variant='light' size='sm' className='rounded-pill cardbtn' onClick={() => handleShow(item[1])}>View Details</Button> */}
              <a className='anchor' target='blank' href={item[1].postIsLink}>Watch Now</a>
              </div>
              </Card.Text>
            </Card.Body>
          </Card>
            </Col>
           ))
           ) : (
            <div className="row justify-content-center pt-4">
              <div className="col-lg-12">
                <div className="noprogramAdded text-center bg-white border shadow p-5">
                  <h2 className="noTaskAdded">Coming Soon</h2>
                  <span>We'll notify you as soon as something becomes available.</span>
                </div>
              </div>
            </div>
            )}

        {/* {selectedPost && (
        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{selectedPost.postTopicName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <img src={selectedPost.postImage} alt='modalimage' className='mb-4'/>
            {parse(selectedPost.postLongDetail)}
            </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )} */}
          </Row>
        </Container>
      </section>

      {/* <section className='service mt-5 pt-5'>
        <Container>
          <Row>
            <Col lg='12'sm="12" className='text-center mb-5'>
            <h1>Services</h1>
              <p className='fs-5 pclr'>If you are looking for custom paintings, which will decorate your home or office,
                 consider booking one or several of<br/> my services listed below. 
                They will add more colors and emotions to your daily life.</p>
            </Col>

            <Col lg='3'sm="12" className='boxmargin'>
              <div className='box rounded shadow'>
                <div className='text-center my-5 py-5'>
                <img src={user} alt='user'/>
                <h3>portrait</h3>
                </div>
              </div>
            </Col>

            <Col lg='3'sm="12" className='boxmargin'>
            <div className='box rounded shadow'>
                <div className='text-center my-5 py-5'>
                <img src={leaf} alt='user'/>
                <h3>Landscape</h3>
                </div>
              </div>
            </Col>

            <Col lg='3'sm="12" className='boxmargin'>
            <div className='box rounded shadow'>
                <div className='text-center my-5 py-5'>
                <img src={apple} alt='user'/>
                <h3>Still Life</h3>
                </div>
              </div>
            </Col>

            <Col lg='3'sm="12" className='boxmargin'>
            <div className='box rounded shadow'>
                <div className='text-center my-5 py-5'>
                <img src={house} alt='user'/>
                <h3>Urban</h3>
                </div>
              </div>
            </Col>
            <Col lg='12' className='text-center mt-5'>
            <Button variant='light' className='rounded-pill learnbtn'>View All Services</Button>
            </Col>
          </Row>
        </Container>
      </section> */}
    </>
  )
}

export default Home
